import './amplify';
export { default as configureStore } from './store';



// WEBPACK FOOTER //
// ./src/configure/index.js